import { memo } from 'react';

import { lazyLoad } from 'utils/loadable';

import { TaxpayerRouting } from './taxpayer.routing';
interface Props {}

export const TaxpayerComponent = memo((props: Props) => {
  return (
    <>
      <div></div>
      <TaxpayerRouting />
    </>
  );
});

TaxpayerComponent.displayName = 'TaxpayerComponent';

export const TaxpayerModule = lazyLoad(
  () => import('./taxpayer.module'),
  (module) => module.TaxpayerComponent
);
